module.exports = __webpack_public_path__ + "img/1_05.0ac49388.jpg";